import styled from "styled-components";

const getBackgroundColorChip = (status) => {
  switch (status) {
    case "CONFIRM":
      return "#129768";
    case "EMPTY":
      return "#BDBDBD";
    case "MAYBE":
      return "#EF9952";
    case "REFUSE":
      return "#E11021";
    default:
      return "#002776";
  }
};

const getColorChip = (status) => {
  switch (status) {
    default:
      return "#ffffff";
  }
};

export const WrapperChip = styled.div`
  div {
    background-color: ${(props) => getBackgroundColorChip(props.status)};
    color: ${(props) => getColorChip(props.status)};
  }
  svg {
    color: ${(props) => getColorChip(props.status)};
  }
`;

export const Circle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${(props) => getBackgroundColorChip(props.status)};
  margin-right: 12px;
`;

export const SlotLink = styled.span`
  color: #002776;
  cursor: pointer;
  text-decoration: underline;
`;
